function isInEnv(domains, host) {
  return domains.find(function (d) {
    return host.endsWith(d);
  });
}

var environments = {
  prod: {
    trustedRootDomains: ['okta.com', 'oktapreview.com', 'okta-emea.com'],
    trustedOrigins: ['https://developer.okta.com'],
    iframeOrigin: 'https://login.okta.com',
    myOktaOrgUrl: 'https://my.okta.com'
  },
  trex: {
    trustedRootDomains: ['trexcloud.com'],
    iframeOrigin: 'https://login.trexcloud.com',
    myOktaOrgUrl: 'https://my.trexcloud.com'
  },
  atko: {
    trustedRootDomains: ['atko.biz', 'clouditude.com'],
    iframeOrigin: 'https://login.atko.biz',
    myOktaOrgUrl: 'https://my.clouditude.com',
  },
  dev: {
    trustedRootDomains: ['okta.io:8080'],
    trustedOrigins: ['http://localhost:4000'],
    iframeOrigin: 'https://login.okta.io:8080',
    myOktaOrgUrl: 'https://my.clouditude.com',
  },
  e2e: {
    trustedRootDomains: ['localhost:8080', 'trexcloud.com'],
    iframeOrigin: 'https://localhost:8080',
    myOktaOrgUrl: 'https://my.clouditude.com'
  },
  empty: {
    trustedRootDomains: [],
    iframeOrigin: '',
  }
};

function getOktaEnvironment(host) {
  return environments[Object.keys(environments).find(function (env) {
    return isInEnv(environments[env].trustedRootDomains, host);
  })] || environments.empty;
}

export default {
  getOktaEnvironment
};



// WEBPACK FOOTER //
// ./lib/environment.js